import request from "components/Utils/Request";
import axios from 'axios';
export const CLIENT_DETAIL_LIST_REQUEST = "CLIENT_DETAIL_LIST_REQUEST";
export const CLIENT_DETAIL_LIST_SUCCESS = "CLIENT_DETAIL_LIST_SUCCESS";
export const CLIENT_DETAIL_LIST_FAILURE = "CLIENT_DETAIL_LIST_FAILURE";
export const GENERATE_CLIENT_DETAIL_LIST_PDF_REQUEST = 'GENERATE_CLIENT_DETAIL_LIST_PDF_REQUEST';
export const GENERATE_CLIENT_DETAIL_LIST_PDF_SUCCESS = 'GENERATE_CLIENT_DETAIL_LIST_PDF_SUCCESS';
export const GENERATE_CLIENT_DETAIL_LIST_PDF_FAILURE = 'GENERATE_CLIENT_DETAIL_LIST_PDF_FAILURE';
const { REACT_APP_API_URL } = process.env;

export const clientDetailListRequest = () => ({
  type: CLIENT_DETAIL_LIST_REQUEST
});
export const clientDetailListSuccess = (payload) => ({
  type: CLIENT_DETAIL_LIST_SUCCESS,
  payload
});
export const clientDetailListFailure = (payload) => ({
  type: CLIENT_DETAIL_LIST_FAILURE,
  payload
})
export const generateClientDetailListPDFRequest = () => ({
  type: GENERATE_CLIENT_DETAIL_LIST_PDF_REQUEST
});
export const generateClientDetailListPDFSuccess = payload => ({
  type: GENERATE_CLIENT_DETAIL_LIST_PDF_SUCCESS,
  payload
});
export const generateClientDetailListPDFFailure = payload => ({
  type: GENERATE_CLIENT_DETAIL_LIST_PDF_FAILURE,
  payload
});

export const clientDetailDataAction = payload => {
  return {
    type: 'CLIENTDETAILDATA',
    payload
  };
};

export const clientDetailsErrorAction = payload => {
  return {
    type: 'CLIENTDETAILERROR',
    payload
  };
};

export const clientDetailListAPI = (payload, successData, errorMSg, headers = {}) => {
  return (dispatch) => {
    dispatch(clientDetailListRequest());
    const url = `${REACT_APP_API_URL}/client-detail-list`;
    return request("POST", url, payload, "", headers)
      .then((res) => {
        if (res?.data.status === 200) {
          successData(res)
          dispatch(clientDetailListSuccess(res));
        } else {
          errorMSg(res)
        }
      }).catch((err) => {
        errorMSg(err?.res);
        dispatch(clientDetailListFailure("Something went wrong"));
        throw err;
      })
  }
}

export const generateClientDetailListPdfAPI = (payload, successCallback, errorCallback, headers = {}) => {
  return dispatch => {
    dispatch(generateClientDetailListPDFRequest());
    axios
      .post(
        `${REACT_APP_API_URL}/client-detail-list`,
        payload,
        {
          responseType: 'blob',
          headers: headers,
        }
      )
      .then(response => {
        if (response.headers['content-type'] === 'application/pdf') {
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const downloadUrl = URL.createObjectURL(blob);
          window.open(downloadUrl, '_blank');

          dispatch(generateClientDetailListPDFSuccess());
        } else {
          errorCallback("Failed to generate PDF");
          dispatch(generateClientDetailListPDFFailure());
        }
      })
      .catch(error => {
        console.error("Error downloading PDF:", error);
        errorCallback("Error occurred while downloading PDF");
        dispatch(generateClientDetailListPDFFailure());
      });
  };
};

